import {provide, ref} from 'vue';
import type {ITabsItem} from '~/interfaces/ui/tabs';

export const useTabs = (emits: any) => {
  const activeTabId = ref('');
  const tabs = ref<Array<ITabsItem>>([]);

  function addTab(tab: ITabsItem) {
    tabs.value.push(tab);
    if (tabs.value.length === 1) {
      selectTab(tabs.value[0].computedId);
    }
  }

  function updateTab(computedId: string, data: ITabsItem) {
    const tabIndex = tabs.value.findIndex(
      (tab) => tab.computedId === computedId,
    );

    data.isActive = tabs.value[tabIndex].isActive;

    tabs.value[tabIndex] = data;
  }

  provide('tabsProvider', {activeTabId, tabs});

  provide('addTab', addTab);

  provide('updateTab', updateTab);

  function selectTab(selectedTabHash: string) {
    const selectedTab = findTab(selectedTabHash);
    if (!selectedTab) {
      return;
    }

    if (selectedTab.isDisabled) {
      return;
    }

    if (activeTabId.value === selectedTab.computedId) {
      emits('clicked', {tab: selectedTab});
      return;
    }

    emits('beforeChange', {tab: selectedTab});

    tabs.value.forEach((tab) => {
      tab.isActive = tab.computedId === selectedTab.computedId;
    });

    emits('changed', {tab: selectedTab});

    activeTabId.value = selectedTab.computedId;
  }

  const findTab = (computedId: string) => {
    return tabs.value.find((tab) => tab.computedId === computedId);
  };

  return {
    findTab,
    selectTab,
    tabs,
    activeTabId,
  };
};
